import styled from 'styled-components';

const PriceTable = ({
  standardPlans,
  premiumPlans,
}: {
  standardPlans: any[];
  premiumPlans: any[];
}) => {
  const mergedPlans = standardPlans.map((standardPlan) => {
    const matchingPremium = premiumPlans.find(
      (premiumPlan) => premiumPlan.plan_name === standardPlan.plan_name,
    );
    return {
      plan_name: standardPlan.plan_name,
      standardPrice: standardPlan.plan_prc,
      premiumPrice: matchingPremium ? matchingPremium.plan_prc : null,
      isDiscount: standardPlan.is_discount === 'Y',
    };
  });

  return (
    <Div>
      <Header>
        <HeaderContent style={{ width: '110px', fontWeight: '500' }}>
          멤버십
        </HeaderContent>
        <HeaderContent style={{ width: '109.5px' }}>Standard</HeaderContent>
        <HeaderContent style={{ width: '109.5px' }}>Premium</HeaderContent>
      </Header>
      <Table>
        {mergedPlans.map((el, idx) => (
          <Content key={idx} isDiscount={el.isDiscount}>
            <Name style={{ width: '110px' }} isDiscount={el.isDiscount}>
              <span>{el.plan_name}</span>
              {el.isDiscount && (
                <span
                  style={{
                    fontSize: '14px',
                    color: '#008AFF',
                    fontWeight: '700',
                  }}
                >
                  50%
                </span>
              )}
            </Name>
            <StandardPrice
              style={{ width: '109.5px' }}
              priceidx={idx}
              isDiscount={el.isDiscount}
            >
              {el.standardPrice.toLocaleString()}원
            </StandardPrice>
            <PremiumPrice priceidx={idx} isDiscount={el.isDiscount}>
              {el.premiumPrice ? (
                `${el.premiumPrice.toLocaleString()}원`
              ) : idx === 4 ? (
                <img
                  src="/assets/images/arrow/gray_none_32.svg"
                  style={{ width: '16px', height: '16px' }}
                />
              ) : (
                ''
              )}
            </PremiumPrice>
          </Content>
        ))}
      </Table>
      <NoteList>
        <Note>・모든 멤버십 요금제는 부가세가 포함된 금액입니다.</Note>
        <Note>
          ・이용기간 안내: 1개월 상품은 구매일 기준 30일간 이용 가능합니다.
        </Note>
      </NoteList>
    </Div>
  );
};

export default PriceTable;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  align-items: flex-start;
`;

const Header = styled.div`
  width: 100%;
  height: 44px;
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  background-color: rgba(112, 115, 124, 0.08);
  font-size: 14px;
  font-weight: 700;
  align-items: center;
  justify-content: space-between;
`;

const HeaderContent = styled.div`
  position: relative;
  text-align: center;
  padding: 12px 14px;
  // &::after {
  //   content: '';
  //   position: absolute;
  //   right: 0;
  //   top: 50%;
  //   transform: translateY(-50%);
  //   width: 1px;
  //   height: 24px;
  //   background-color: rgba(112, 115, 124, 0.22);
  // }
  // &:last-child::after {
  //   display: none;
  // }
`;

const Division = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Content = styled.div<{ isDiscount: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ isDiscount }) =>
    isDiscount ? '#EDF6FF' : 'transparent'};
  border-radius: ${({ isDiscount }) => (isDiscount ? '12px' : '0px')};
`;

const Name = styled.div<{ isDiscount?: boolean }>`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  font-weight: ${({ isDiscount }) => (isDiscount ? '700' : '500')};
  font-size: 14px;
  width: 110px;
  border-radius: 12px;
  background-color: ${({ isDiscount }) =>
    isDiscount ? '#EDF6FF' : 'rgba(112, 115, 124, 0.05)'};
  padding: 12px;
`;

const StandardPrice = styled.div<{ priceidx: number; isDiscount: boolean }>`
  font-size: 14px;
  width: 101px;
  font-weight: 700;
  color: ${({ isDiscount }) => (isDiscount ? '#008AFF' : '#222222')};
  text-align: center;
  padding: 12px;
  display: flex;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    right: -8px;
    ${({ priceidx }) =>
      priceidx === 0
        ? 'bottom: -15%'
        : priceidx >= 2
          ? 'top: 45%'
          : 'top: 55%'};
    transform: translateY(-50%);
    width: 1px;
    height: ${({ priceidx }) =>
      priceidx === 1 ? '45px' : priceidx > 1 ? '54px' : '30px'};
    background-color: rgba(112, 115, 124, 0.22);
  }
  &:last-child::after {
    display: none;
  }
`;

const PremiumPrice = styled.div<{ priceidx: number; isDiscount: boolean }>`
  font-size: 14px;
  width: 109px;
  font-weight: 700;
  color: ${({ isDiscount }) => (isDiscount ? '#008AFF' : '#222222')};
  text-align: center;
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const NoteList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

const Note = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-weight: 500;
`;
